import { useMutation, useQueryClient } from '@tanstack/react-query';
import { aiAgentApis } from '../../../../../../../shared/apis/ai-agent/apis';
import { showSuccessNotification } from '../../../../../../ui/notification';
import { handleError } from '../../../../../../ui/err/handleError';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../../../shared/types';
import { queries } from '../../../../../../../shared/queries';

export default function useDeleteTemplate() {
  const queryClient = useQueryClient();

  return useMutation(aiAgentApis.template.deleteAsCsTemplate, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queries.aiAgent.asCsTemplateList._def,
      });
      showSuccessNotification('템플릿이 삭제되었습니다.');
    },
    onError: (error) => {
      handleError(error as AxiosError<AxiosCommonError>);
    },
  });
}
